//import { apiUrl as api_url } from "../utils/helpers/enviroment.helpers";
import { fetchWithCredentials, handleErrorsStatus } from "./httpService";

const api_path = "FechasCalendario/CentroRecreativo/";

export const getFechasCalendario = async (criID) => {
  try {
    const respuesta = await fetchWithCredentials(
      window.__CONFIG__.apiPrincipal + api_path + criID,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return await handleErrorsStatus(respuesta);
  } catch (err) {
    console.error("Error", err);
    throw new Error("Ocurrió un error al buscar las fechas disponibles.");
  }
};